function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.6133 4.58203H4.61328C3.51328 4.58203 2.62328 5.48203 2.62328 6.58203L2.61328 18.582C2.61328 19.682 3.51328 20.582 4.61328 20.582H20.6133C21.7133 20.582 22.6133 19.682 22.6133 18.582V6.58203C22.6133 5.48203 21.7133 4.58203 20.6133 4.58203ZM20.2133 8.83203L13.1433 13.252C12.8233 13.452 12.4033 13.452 12.0833 13.252L5.01328 8.83203C4.76328 8.67203 4.61328 8.40203 4.61328 8.11203C4.61328 7.44203 5.34328 7.04203 5.91328 7.39203L12.6133 11.582L19.3133 7.39203C19.8833 7.04203 20.6133 7.44203 20.6133 8.11203C20.6133 8.40203 20.4633 8.67203 20.2133 8.83203Z",
  fill: "#233539"
});

function SvgInboxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIcon);
export default __webpack_public_path__ + "static/media/inbox-icon.27c31e25.svg";
export { ForwardRef as ReactComponent };